import React, { useState } from 'react';
import { PS } from '../theme';
import { Icon } from '../lib/icons';
import api from '../lib/api';
import { notifySuccess, notifyError } from '../lib/toast';

function Stars({ value, onPick, size = 30 }) {
  return (
    <div style={{ display: 'flex', gap: 8, justifyContent: 'center' }}>
      {[1, 2, 3, 4, 5].map((n) => (
        <button key={n} data-testid={`star-${n}`} onClick={() => onPick?.(n)} className="ps-press"
          style={{ background: 'none', border: 'none', cursor: onPick ? 'pointer' : 'default', padding: 0, lineHeight: 1, color: n <= value ? PS.gold : PS.line, fontSize: size }}>★</button>
      ))}
    </div>
  );
}

// Member-only host review (1-5 stars + comment). Editable (one per circle).
export default function ReviewSheet({ circleId, hostName, existing, onClose, onSaved }) {
  const [rating, setRating] = useState(existing?.rating || 0);
  const [comment, setComment] = useState(existing?.comment || '');
  const [busy, setBusy] = useState(false);

  const submit = async () => {
    if (!rating) return notifyError('กรุณาเลือกดาว 1-5');
    setBusy(true);
    try {
      const res = await api.post(`/circles/${circleId}/review`, { rating, comment });
      notifySuccess('บันทึกรีวิวแล้ว');
      onSaved?.(res.data);
      onClose();
    } catch (e) {
      notifyError(e?.response?.data?.detail || 'ให้รีวิวไม่สำเร็จ');
    } finally { setBusy(false); }
  };

  return (
    <div onClick={onClose} style={{ position: 'fixed', inset: 0, background: 'rgba(20,18,16,0.5)', display: 'flex', alignItems: 'flex-end', justifyContent: 'center', zIndex: 1600 }}>
      <div onClick={e => e.stopPropagation()} className="ps-fade-up" data-testid="review-sheet" style={{ width: '100%', maxWidth: 460, background: PS.surface2, borderRadius: '24px 24px 0 0', padding: '20px 20px max(20px, env(safe-area-inset-bottom))', fontFamily: PS.fontUI }}>
        <div style={{ width: 40, height: 4, borderRadius: 2, background: PS.line, margin: '0 auto 18px' }} />
        <div style={{ textAlign: 'center', fontSize: 17, fontWeight: 700 }}>{existing ? 'แก้ไขรีวิว' : 'ให้ดาวท้าวแชร์'}</div>
        <div style={{ textAlign: 'center', fontSize: 12.5, color: PS.textMuted, marginTop: 4, marginBottom: 18 }}>{hostName}</div>
        <div style={{ marginBottom: 18 }}><Stars value={rating} onPick={setRating} /></div>
        <textarea data-testid="review-comment" value={comment} onChange={e => setComment(e.target.value)} rows={3} placeholder="ประสบการณ์กับท้าวคนนี้ (ไม่บังคับ) — เช่น โอนตรงเวลา จัดการดี"
          style={{ width: '100%', borderRadius: 12, border: `1px solid ${PS.line}`, padding: 12, fontSize: 13.5, fontFamily: PS.fontUI, background: PS.surface, outline: 'none', resize: 'vertical' }} />
        <button data-testid="review-submit-btn" disabled={busy || !rating} onClick={submit} className="ps-press" style={{ width: '100%', height: 50, marginTop: 14, background: PS.ink, color: PS.page, border: 'none', borderRadius: 14, fontSize: 14, fontWeight: 600, fontFamily: PS.fontUI, opacity: busy || !rating ? 0.6 : 1 }}>
          {busy ? 'กำลังบันทึก…' : existing ? 'อัปเดตรีวิว' : 'ส่งรีวิว'}
        </button>
      </div>
    </div>
  );
}

export { Stars };
